<script setup lang="ts">
defineProps<{
  html: string
  description?: string
}>()
</script>

<template>
  <div v-html="html" />
</template>
